import { render, staticRenderFns } from "./GChatActiveChatContentDetailsSidedbar.vue?vue&type=template&id=55f25c88&"
import script from "./GChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js&"
export * from "./GChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports